<template lang="pug">
	.project-actions-clone(v-if="showed && Project.SelectedProject")
		.card
			.card-header
				i.fa.fa-edit
				span Clone Project
			.card-body.collapse.show
				.form-horizontal
					.form-group
						label.col-form-label(for="prependedInput") New title of project
							.controls
								input.form-control(id="prependedInput" size="16" type="text" v-model="title")
						.debug-settings
							label.col-form-label(:style="{width: '190px'}") Clone all tracking
							label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label(:style="{'background-color': '#343b41'}")
								input.switch-input.form-check-input(type="checkbox" :checked="cloneTracking" @change="switchTrackingSettings($event.target.checked)")
								span.switch-slider(data-checked="On" data-unchecked="Off")
								span.switch-handle
						.debug-settings
							label.col-form-label(:style="{width: '190px'}") Clone only matomo tracking
							label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label(:style="{'background-color': '#343b41'}")
								input.switch-input.form-check-input(type="checkbox" :checked="cloneMatomoTracking" @change="switchMatomoTrackingSettings($event.target.checked)")
								span.switch-slider(data-checked="On" data-unchecked="Off")
								span.switch-handle
					.form-actions
						button.btn.btn-primary(type="submit" v-on:click="clone()") Clone project
						button.btn.btn-ghost-dark(type="button" v-on:click="hide()") Cancel
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Template } 		from './../../services/Template';
	import { Project } 			from './../../services/Project';

	import { Notifications }	from './../../services/Notifications';

	export default {
		name: "ProjectActionsClone",
		mixins: [Screen],
		screen: {
			updateOn: []
		},
		data() {

			this.Template = Template;
			this.Project = Project;

			this.cloneTracking = false;
			this.cloneMatomoTracking = false;

			return {
				title: ''
			}
		},
		methods: {
			collectData() {

				if (!Project.SelectedProject) return;

				this.title = Project.SelectedProject.title;

				this.cloneTracking = false;
				this.cloneMatomoTracking = false;

			},
			clone() {

				const new_name = this.title.trim();

				if (!new_name) return Notifications.showError(`Invalid project name!`);


				Broadcast.call("Project Cloned");

				Server.sendToSocket({
					CloneProject: {
						templateId: Project.SelectedProject.template_id,
						projectId: Project.SelectedProject.id,
						title: this.title,
						cloneTracking: this.cloneTracking,
						cloneMatomoTracking: this.cloneMatomoTracking
					}
				});

				this.hide();

			},
			switchTrackingSettings(value) {
				this.cloneTracking = value;
				if (value === true && this.cloneMatomoTracking) {
					this.switchMatomoTrackingSettings(false);
				}
				this.$forceUpdate();
			},
			switchMatomoTrackingSettings(value) {
				this.cloneMatomoTracking = value;
				if (value === true && this.cloneTracking) {
					this.switchTrackingSettings(false);
				}
				this.$forceUpdate();
			}
		}
	}
</script>


<style lang="sass">

	.project-actions-clone
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 345px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			input
				width: 460px
				margin-top: 5px

			.btn-ghost-dark
				float: right
				color: #fff

			.debug-settings
				display: flex
				flex-direction: row
				color: #e4e7ea
				align-items: center

				.switch-slider
					background-color: #3a4149

</style>

